import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import { NavbarPlugin } from 'bootstrap-vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import { CollapsePlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtag from 'vue-gtag'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAxios, axios)

Vue.use(VueCookies)
Vue.use(TabsPlugin)
Vue.use(CollapsePlugin)

Vue.use(VueRouter)

window.$ = window.jQuery = require('jquery');

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

Vue.use(VueAnalytics, {
  id: 'UA-147975526-1',
  router
})

Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(NavbarPlugin)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js